import { createTransport } from "@/src/config/transportFactory.js";
import { coderTransport } from "@/src/config/coderTransport.js";

const { transport: customDomains } = createTransport("customDomains");

export default {
  async listWorkspaceDomains() {
    try {
      const res = await coderTransport.get("/v1/custom-domains");
      return res.data?.data ?? [];
    } catch (error) {
      console.error(
        "An error occurred while executing listWorkspaceDomains: ",
        error,
      );
      throw error;
    }
  },

  async createDomain(domain) {
    try {
      const res = await customDomains.post("", {
        domain,
        parked: true,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing createDomain: ", error);
      throw error;
    }
  },

  async getDomainStatus(id) {
    try {
      const res = await customDomains.get(`/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing getDomainStatus: ",
        error,
      );
      throw error;
    }
  },

  async destroyDomain(id) {
    try {
      const res = await customDomains.delete(`/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing destroyDomain: ", error);
      throw error;
    }
  },

  async detachDomainFromApp(appId, domainId) {
    try {
      const res = await coderTransport.delete(
        `/v1/apps/${appId}/custom-domains/${domainId}`,
      );
      return res.data?.data ?? res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing detachDomainFromApp: ",
        error,
      );
      throw error;
    }
  },
};
